<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <div class="awair-form">

    <div class="header-group">
      <div class="left">
        Air note
      </div>
    </div>

    <div class="divider">
    </div>

    <table>
      <tr>
        <td class="row-key">Device</td>
        <td class="row-value device-name">{{selectedDevice.deviceName}}</td>
      </tr>
      <tr>
        <td class="row-key">Time</td>
        <td class="row-value">{{date | date:'H:mm, d MMM'}}</td>
      </tr>
      <tr>
        <td class="row-key">Event</td>
        <td class="row-value">
          <div class="status-circle" [style.background]="valueColor"></div>
          {{type | sensorHeader}} {{value | tempConverter: type: temperatureUnit | number: '1.0-1'}}
          {{type | sensorUnit : temperatureUnit}}
        </td>
      </tr>
    </table>

    <div class="divider" style="margin-top: 8px; margin-bottom: 16px;">
    </div>

    <textarea class="note" autofocus placeholder="example: Carpets Cleaned with Organic Chemicals"
              [(ngModel)]="note"></textarea>

    <div class="button-group">
      <button class="dialog-cancel-btn" (click)="close()">Close</button>
      <button class="dialog-btn" [disabled]="note.length < 1" (click)="saveAirNote(selectedOrganization.token)">Save</button>
    </div>
  </div>
</ng-container>


